import { OnboardingStepProps, PAIN_POINTS, PainPoint } from './types';

export function StepPain({ state, onUpdate, onNext }: OnboardingStepProps) {
  const handleSelect = (painPoint: PainPoint) => {
    onUpdate({ painPoint });
  };

  return (
    <div className="animate-fade-in">
      <div className="text-center mb-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-surface-900 mb-4">
          What's making hiring hard right now?
        </h1>
        <p className="text-lg text-surface-500 max-w-xl mx-auto">
          We'll personalize your experience based on what you're dealing with.
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-3">
        {PAIN_POINTS.map((point) => {
          const isSelected = state.painPoint === point.id;
          return (
            <button
              key={point.id}
              onClick={() => handleSelect(point.id)}
              className={`
                w-full text-left p-5 rounded-xl border-2 transition-all duration-200
                ${isSelected
                  ? 'border-brand-500 bg-brand-50 shadow-sm'
                  : 'border-surface-200 bg-white hover:border-surface-300 hover:shadow-sm'
                }
              `}
            >
              <div className="flex items-start gap-4">
                <div className={`
                  mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors
                  ${isSelected ? 'border-brand-500 bg-brand-500' : 'border-surface-300'}
                `}>
                  {isSelected && (
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
                <div>
                  <p className={`font-semibold ${isSelected ? 'text-brand-700' : 'text-surface-900'}`}>
                    {point.label}
                  </p>
                  <p className="text-sm text-surface-500 mt-0.5">
                    {point.description}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <div className="mt-12 flex flex-col items-center gap-4">
        <button
          onClick={onNext}
          className="btn text-base px-10 py-3.5 transition-all duration-200 bg-brand-600 text-white hover:bg-brand-700 shadow-lg shadow-brand-500/25"
        >
          Continue
          <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd" />
          </svg>
        </button>
        {!state.painPoint && (
          <button
            onClick={onNext}
            className="text-sm text-surface-500 hover:text-surface-700 transition-colors"
          >
            Skip for now
          </button>
        )}
      </div>
    </div>
  );
}

